export const TOKEN_SECRET = "$dsA^";

export const IMG_BASE_URL = "https://api.sharif-school.ir/";

export const FILE_BASE_URL = "https://api.sharif-school.ir/";

export const PY_IMG_BASE_URL = "https://fast-api.dadekavwebtools.ir/";

export const PAGINATION_LIMIT = 10;
